module.exports = __webpack_public_path__ + "img/nadneda_yes.4996ace2.png";